/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Achintya Garg",
  title: "Hi all, I'm Achintya",
  subTitle: emoji(
    "A passionate Software Developer 🚀 having experience building data pipelines, cloud tools and Quantitative analysis"
  ),
  resumeLink:
    "https://docs.google.com/document/d/15-Asj0AY1Z_VWc9v_1-CqDbeqWH2ciBbtAPj4-iFFxU/edit?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/achintyagarg",
  linkedin: "https://www.linkedin.com/in/achintya-garg-0b492b213/",
  gmail: "achintyagarg01@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "Quant-oriented Software Engineer focused on systematic trading research, pricing models, and production-grade data pipelines.",
  skills: [
    emoji(
      "⚡ Build end-to-end quant research workflows: data → signals → backtests → evaluation"
    ),
    emoji("⚡ Develop statistical/ML models for forecasting, factor research, and risk management"),
    emoji(
      "⚡ Engineer market data pipelines (ETL), APIs, and dashboards for analytics and decision support"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
  {
    skillName: "Python",
    fontAwesomeClassname: "fab fa-python"
  },
  {
    skillName: "NumPy / Pandas",
    fontAwesomeClassname: "fas fa-chart-line"
  },
  {
    skillName: "Machine Learning",
    fontAwesomeClassname: "fas fa-brain"
  },
  {
    skillName: "Statistical Modeling",
    fontAwesomeClassname: "fas fa-square-root-alt"
  },
  {
    skillName: "Time Series Analysis",
    fontAwesomeClassname: "fas fa-wave-square"
  },
  {
    skillName: "SQL / Databases",
    fontAwesomeClassname: "fas fa-database"
  },
  {
    skillName: "APIs & Data Pipelines",
    fontAwesomeClassname: "fas fa-project-diagram"
  },
  {
    skillName: "Docker",
    fontAwesomeClassname: "fab fa-docker"
  },
  {
    skillName: "Cloud Computing",
    fontAwesomeClassname: "fab fa-aws"
  },
  {
    skillName: "Linux",
    fontAwesomeClassname: "fab fa-linux"
  }
],
display: true
};

// Education Section

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Stevens Institute of Technology",
      logo: require("./assets/images/Stevens.png"),
      subHeader: "Master of Science in Financial Engineering",
      duration: "2025 – May 2026",
      desc:
        "Graduate program focused on quantitative finance, stochastic modeling, and algorithmic trading with strong emphasis on applied computation.",
      descBullets: [
        "GPA: 3.95",
        "Algorithmic Trading Graduate Certificate (in progress)",
        "Coursework includes derivatives pricing, portfolio optimization, and quantitative risk modeling"
      ]
    },
    {
      schoolName: "Virginia Tech",
      logo: require("./assets/images/VTlogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "2020 – July 2024",
      desc:
        "Strong foundation in computer science, software engineering, and systems with leadership experience in student organizations.",
      descBullets: [
        "Dean’s List: Fall 2020, Fall 2024",
        "Treasurer, Virginia Tech Badminton Club",
        "Coursework in algorithms, operating systems, and software engineering"
      ]
    }
  ]
};


// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true,
  experience: [
    {
      Stack: "Quantitative Modeling & Finance",
      progressPercentage: "70%"
    },
    {
      Stack: "Data Engineering & Pipelines",
      progressPercentage: "85%"
    },
    {
      Stack: "Statistical Analysis & Machine Learning",
      progressPercentage: "80%"
    },
    {
      Stack: "Backend Systems & APIs",
      progressPercentage: "85%"
    },
    {
      Stack: "Software Engineering (OOP, Design, Testing)",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false
};


// Work experience section

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Data Engineer & Investran Administrator",
      company: "Onex",
      companylogo: require("./assets/images/onex.png"),
      date: "January 2025 – October 2025",
      desc:
        "Built and maintained production-grade financial data systems and internal platforms supporting private equity and CLO operations.",
      descBullets: [
        "Developed a CLO Payment Waterfall API integrating SOFR, LIBOR, and EURIBOR curves to project multi-quarter cash flows using SQL Server",
        "Designed a modular Spring Boot ETL framework with REST-callable worker modules and factory-style architecture for scalable data pipelines",
        "Built an agentic Snowflake Cortex Analyst chatbot and integrated it into the firm’s investment portal as a REST API",
        "Administered Investran by managing security matrices, licenses, fiscal closings, and operational reporting tools (SSRS, ILPA, CRM)"
      ]
    },
    {
      role: "AI Tools Engineer Intern",
      company: "LumberFi",
      companylogo: require("./assets/images/lumberfi.webp"),
      date: "May 2024 – August 2024",
      desc:
        "Designed LLM-powered document processing pipelines to convert unstructured operational data into structured, queryable formats.",
      descBullets: [
        "Built an Azure Function App pipeline using OCR and LangChain workflows powered by GPT models to process PDF logs into JSON",
        "Developed a local LLM-based document Q&A system enabling natural-language interaction with uploaded PDFs",
        "Improved accessibility and usability of internal data by enabling contextual search and semantic querying"
      ]
    },
    {
      role: "Digital Cloud Infrastructure Intern",
      company: "Harman International",
      companylogo: require("./assets/images/harman.png"),
      date: "May 2023 – August 2023",
      desc:
        "Worked on cloud security automation and monitoring systems using AWS-native services.",
      descBullets: [
        "Built security dashboards using AWS Athena, Config, Lambda, S3, and QuickSight",
        "Automated GuardDuty incident response to isolate EC2 instances, revoke IAM sessions, and block public S3 access",
        "Improved cloud security posture through automated detection and remediation workflows"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle:
    "SELECTED QUANTITATIVE FINANCE AND DATA ENGINEERING PROJECTS — RESEARCH, INFRASTRUCTURE, AND PRODUCTION IMPLEMENTATIONS",
  projects: [
    {
      // image: require("./assets/images/dynamicBetaHedgeLogo.webp"),
      projectName: "Dynamic Beta Hedging Model (AAPL)",
      projectDesc:
        "Modeled AAPL’s systematic risk using CAPM and built dynamic rolling hedges (60-day) to evaluate beta stability, volatility reduction, and tail-risk behavior. Implemented minimum-variance and beta-neutral hedges, including a synthetic ETF basket replicating AAPL’s beta.",
      footerLink: [
        {
          name: "View Project (GitHub)",
          url: "https://github.com/achintyagarg"
        }
      ]
    },
    {
      // image: require("./assets/images/etlFrameworkLogo.webp"),
      projectName: "Spring Boot ETL Framework (Factory Architecture)",
      projectDesc:
        "Designed a modular ETL framework with REST-callable, job-specific worker modules instantiated via a factory pattern. Enabled scalable, parameterized workflows for database ingestion, file generation, and SFTP delivery pipelines with CI/CD integration.",
      footerLink: [
        {
          name: "View Project (GitHub)",
          url: "https://github.com/achintyagarg"
        }
      ]
    },
    {
      // image: require("./assets/images/adaptiveVolatilityLogo.webp"),
      projectName: "Adaptive Volatility Regime Execution & Risk Framework (HMM + HAR-RV-J)",
      projectDesc:
        "Built a regime-aware execution and risk system using noise-robust volatility (TSRV), jump decomposition (BV/RJ), HAR-RV-J forecasting, and a 3-state Gaussian HMM for latent regime detection. Adapted execution style (VWAP/TWAP/Passive) and position sizing via CVaR-based risk controls.",
      footerLink: [
        {
          name: "View Repository",
          url: "https://github.com/achintyagarg/Adaptive-Volatility-Regime-Based-Execution-and-Risk-Framework"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};


// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+1-(540)-824-9143",
  email_address: "achintyagarg01@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
